import React, {
  MouseEventHandler,
  RefObject,
  useEffect,
  useRef,
  useState,
} from "react";
import { useHistory } from "react-router-dom";
import { Icon } from "../icon";

const useOnClickOutside = (
  ref: RefObject<HTMLElement>,
  handler: MouseEventHandler<HTMLButtonElement>
) => {
  useEffect(() => {
    const listener = (event: any) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return () => {
      document.removeEventListener("touchstart", listener);
      document.removeEventListener("mousedown", listener);
    };
  }, [ref, handler]);
};

const HeaderDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);
  const history = useHistory();
  useOnClickOutside(ref, () => setIsOpen(false));
  return (
    <div className="header-dropdown">
      <div ref={ref} className={`dropdown ${isOpen ? "open" : ""}`}>
        <button
          className="btn-dropdown"
          onClick={() => setIsOpen((state) => !state)}
        >
          <Icon.Profile />
        </button>
        <div className="menu">
          <span onClick={() => history.push("/profile")}>Hồ sơ</span>
          {/* <span onClick={() => UserService.logout()}>Đăng xuất</span> */}
        </div>
      </div>
    </div>
  );
};

export default HeaderDropdown;
